import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, SubmissionError, reset } from 'redux-form'
import { PulseLoader } from 'halogen'
import { appendToFormData } from '../../helpers/utility'
import { SIGNUP_REQUEST } from '../../actions/actions'
import { Row, Grid, Icon, Form, Button, FormGroup, InputGroup } from '@sketchpixy/rubix'

const styles = {
  wrapper: {
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    padding: 25,
    paddingTop: 0,
    paddingBottom: 0,
    margin: 'auto',
    marginBottom: 25,
    marginTop: 25,
  },
  centerAlign: { textAlign: 'center' },
}

class AppSignup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successful: false,
    }
  }

  email = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="email">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <Icon className="fa fa-envelope" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="email"
            className="border-focus-blue"
            placeholder="ایمیل ثبت کننده"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  mobile = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="mobile">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <Icon className="fa fa-mobile" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="text"
            className="border-focus-blue"
            placeholder="شماره موبایل ثبت کننده"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  name = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="firstName">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <Icon className="fa fa-address-card" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="text"
            className="border-focus-blue"
            placeholder="نام ثبت کننده"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  title = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="firstName">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <Icon className="fa fa-address-card" aria-hidden="true" />
          </InputGroup.Addon>
          <input
            type="text"
            className="border-focus-blue"
            placeholder="عنوان اپلیکیشن"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  description = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <FormGroup controlId="info">
        <div className="form-error">{hasError && error}</div>
        <InputGroup bsSize="large">
          <InputGroup.Addon>
            <Icon className="fa fa-info" aria-hidden="true" />
          </InputGroup.Addon>
          <textarea
            type="text"
            className="border-focus-blue"
            placeholder="توضیحات اپلیکشین"
            {...input}
            {...custom}
          />
        </InputGroup>
      </FormGroup>
    )
  }

  onSubmit = values => {
    const { dispatch, updateParent } = this.props
    const formData = appendToFormData(values)

    return new Promise((resolve, reject) => {
      dispatch({
        type: SIGNUP_REQUEST,
        resolve,
        reject,
        formData,
        userType: 'APP',
      })
    })
      .then(data => {
        if (updateParent) {
          updateParent(data)
          dispatch(reset('TeacherSignup'))
        } else {
          this.setState({ app: data.application, successful: true })
        }
      })
      .catch(response => {
        throw new SubmissionError({
          _error: response.general_errors[0],
          ...response.form_errors,
        })
      })
  }

  render() {
    const { handleSubmit, error, id } = this.props
    if (this.state.successful) {
      return (
        <div style={styles.centerAlign}>
          <h3>اپکلیکیشن شما با موفقیت ثبت شد</h3>
          <h4>{this.state.app.title}</h4>
        </div>
      )
    }

    return (
      <div style={styles.wrapper} id={id && id}>
        <h4>ثبت اپلیکیشن</h4>

        <Form onSubmit={handleSubmit(this.onSubmit)}>
          <Field name="title" component={this.title} />
          <Field name="description" component={this.description} />
          <Field name="owner_name" component={this.name} />
          <Field name="owner_email" component={this.email} />
          <Field name="owner_phone_number" component={this.mobile} />

          <Grid>
            <Row style={{ textAlign: 'center', padding: '5px' }}>
              {error && <strong>{error}</strong>}
            </Row>

            <Row style={styles.centerAlign}>
              {!this.props.aSyncCall ? (
                <Button
                  lg
                  type="submit"
                  active
                  bsStyle="primary"
                  className="auth-buttons"
                >
                  ثبت
                </Button>
              ) : (
                <div style={styles.loading}>
                  <PulseLoader color="#275C8A" size="10px" />
                </div>
              )}
            </Row>
          </Grid>
        </Form>
      </div>
    )
  }
}

const validate = values => {
  let errors = {}

  if (!values.title) {
    errors.title = 'عنوان اجباری است'
  }

  if (!values.owner_name) {
    errors.owner_name = 'نام ثبت کننده اجباری است'
  }

  if (!values.owner_phone_number) {
    errors.owner_phone_number = 'شماره موبایل ثبت کننده اجباری است'
  }

  if (!values.owner_email) {
    errors.owner_email = 'ایمیل ثبت کننده اجباری است'
  }

  return errors
}

AppSignup = reduxForm({
  form: 'AppSignup',
  validate,
})(AppSignup)

export default connect()(AppSignup)



// WEBPACK FOOTER //
// ./src/components/app/AppSignup.js